var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "totals" },
      [
        _vm._l(_vm.state.totals, function (total, i) {
          return [
            !total.Hidden
              ? _c(
                  "div",
                  { key: i, staticClass: "total", style: total.getStyle() },
                  [_c("div", [_vm._v(" " + _vm._s(total.Text) + " ")])]
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }